export const navbar = {
  officeName: '大家行政书士事务所',
  home: '首页',
  services: '服务内容',
  pricing: '收费标准',
  testimonials: '客户评价',
  contact: '联系我们',
  faq: '常见问题',
  freeConsultation: '免费咨询',
};

export const hero = {
  chineseSupport: '中文服务',
  title: '大家行政书士事务所',
  subtitle: '会说中文的专业人员为您提供安心可靠的支持',
  description: '从签证申请到公司设立，为中国客户提供专业服务',
  bookConsultation: '预约免费咨询',
  serviceDetails: '服务详情',
  feature1Title: '全中文服务',
  feature1Desc: '会说中文的专业人员直接对应',
  feature2Title: '丰富经验',
  feature2Desc: '成功帮助众多中国客户办理手续',
  feature3Title: '快速响应',
  feature3Desc: '保证24小时内回复',
};

export const services = {
  title: '中文服务项目',
  subtitle: '会说中文的行政书士理解中国客户的特殊需求，用母语为您提供安心的咨询服务',
  service1Title: '签证・在留资格申请',
  service1Desc: '工作签证、家族滞在、永住权申请等，用中文为中国客户提供在留资格相关手续支持',
  service2Title: '公司设立・经营支援',
  service2Desc: '全方位支持中国客户创业。从设立到取得经营管理签证，全程中文对应',
  service3Title: '建设业许可申请',
  service3Desc: '支持中国经营者进入建设行业。从许可要求到申请，用中文详细说明',
  service4Title: '归化申请支援',
  service4Desc: '为希望取得日本国籍的中国客户提供服务。用中文细心支持复杂的归化手续',
  service5Title: '运输业许可申请',
  service5Desc: '支持中国客户进入运输行业。从许可取得到开始营业，全程中文对应',
  service6Title: '各类许可申请',
  service6Desc: '餐饮店营业许可、古物商许可等，用中文支持中国客户业务所需的各类许可',
  chineseSupportTitle: '全中文服务',
  chineseSupportDesc: '会说中文的专业人员从初次咨询到手续完成全程支持。复杂的法律内容も用母語详细说明。',
  chineseConsultation: '中文咨询',
  chineseConsultationDesc: '从初次咨询开始就可用中文详细咨询',
  documentTranslation: '文件翻译',
  documentTranslationDesc: '中文文件的日语翻译对应',
  support24h: '24小时对应',
  support24hDesc: '中文紧急咨询也可对应',
  consultInChinese: '中文免费咨询',
};

export const pricing = {
  title: '收费标准',
  subtitle: '透明清晰的收费标准，让您安心委托',
  category1: '签证・在留资格',
  category2: '公司设立',
  category3: '建设业许可',
  category4: '归化申请',
  category5: '其他许可',
  freeConsultationTitle: '初次咨询免费',
  freeConsultationDesc: '详细了解您的需求后，为您提供准确的费用和手续流程',
  quickResponse: '快速响应',
  quickResponseDesc: '24小时内回复',
  expertise: '专业性',
  expertiseDesc: '丰富的实绩和经验',
  carefulSupport: '细心支持',
  carefulSupportDesc: '负责到底',
  bookFreeConsultation: '预约免费咨询',
  note1: '※ 以上费用为参考价格。根据案件复杂程度可能有所变动',
  note2: '※ 政府部门手续费、翻译费、公证费用等实际费用需另外支付',
};

export const testimonials = {
  title: '中国客户的评价',
  testimonialsTitle: '客户评价',
  subtitle: '通过可以用中文安心咨询的服务，众多中国客户表示满意',
  client1Name: '李 明华',
  client1Role: 'IT企业经营者',
  client1Content: '咨询了经营管理签证的申请。用中文详细说明，复杂的手续也能安心进行。多亏了您，从公司设立到取得在留资格全部顺利完成。',
  client2Name: '王 美玲',
  client2Role: '餐饮店老板',
  client2Content: '委托办理了餐饮店开业的许可申请。可以用中文咨询，细节问题也能毫无顾虑地提问。从开业到现在一直得到细心支持，真的非常感谢。',
  client3Name: '張 健',
  client3Role: '建设公司代表',
  client3Content: '在取得建设业许可时遇到困难，能遇到会说中文的老师真是太好了。从许可要求到申请文件，全部用中文细心说明，顺利取得了许可。',
  client4Name: '陈 小红',
  client4Role: '永住权取得者',
  client4Content: '永住权申请得到了8年的照顾。可以用中文咨询，微妙的语感也能准确传达，申请文件も准备得很完美。顺利取得了永住权。',
  client5Name: '刘 強',
  client5Role: '运输业经营者',
  client5Content: '委托办理了运输业许可の申请。用中文详细教授了法规制度，还一起制作了事业计划。取得许可後の运营も得到了建议，非常有帮助。',
  client6Name: '黄 婷婷',
  client6Role: '归化申请者',
  client6Content: '归化申请の手续得到了照顾。从中国户籍相关文件の準備到面试对策，全部用中文支持。虽然手续复杂，但可以安心委托。',
  chineseStaffTitle: '会说中文的专业人员直接对应',
  chineseStaffDesc: '不会感到语言障碍，复杂的法律手续も用母語安心咨询。理解中国客户特殊需求の专家，为您提供最佳解决方案。',
  tag1: '中文对应',
  tag2: '专业知识',
  tag3: '快速响应',
  tag4: '丰富実績',
};

export const contact = {
  title: '联系我们',
  subtitle: '请随时咨询。24小时内回复。可用日语、英语对应。',
  officeLocation: '事务所地址',
  address: '〒162-0811\n东京都新宿区水道町3-14\n神乐坂N大楼 2-M',
  phoneConsultation: '电话咨询',
  businessHours: '营业时间：9:00-18:00（周一至周五）',
  emailConsultation: '邮件咨询',
  emailResponse: '24小时内回复',
  accessTitle: '交通方式',
  access1: '东京地铁东西线「神乐坂站」步行5分钟',
  access2: '都营大江户线「牛込神乐坂站」步行8分钟',
  access3: 'JR「饭田桥站」步行10分钟',
  formTitle: '在线咨询表单',
  successMessage: '发送完成！',
  successDesc: '已收到您的咨询。我们将在24小时内回复。',
  errorMessage: '发送失败',
  errorDesc: '请稍后再试，或通过电话联系我们。',
  nameLabel: '姓名',
  namePlaceholder: '请输入您的姓名',
  emailLabel: '邮箱地址',
  emailPlaceholder: 'example@email.com',
  phoneLabel: '电话号码',
  phonePlaceholder: '090-1234-5678',
  serviceLabel: '咨询内容',
  servicePlaceholder: '请选择服务',
  serviceOption1: '签证・在留资格',
  serviceOption2: '公司设立・经营',
  serviceOption3: '建设業许可',
  serviceOption4: '归化申请',
  serviceOption5: '运输業许可',
  serviceOption6: '其他许可申请',
  messageLabel: '详细内容',
  messagePlaceholder: '请填写咨询的详细内容（500字以内）',
  messageNote: '※ 请在500字以内输入',
  submitting: '发送中...',
  submitButton: '发送咨询',
  required: '*',
};

export const faq = {
  title: '常见问题',
  subtitle: '回答中国客户经常提出的问题。也接受用中文的详细咨询。',
  q1: '可以用中文咨询吗？',
  a1: '可以，会说中文的专业人员直接对应。从初次咨询到手续完成，全部可用中文支持。复杂的法律内容も用母語详细说明。',
  q2: '中国的文件需要翻译成日语吗？',
  a2: 'はい，提交给日本行政机关の文件は日語翻訳が必要です。本事务所も中文ファイルの翻訳サービスを提供しています。正確な翻訳と認証手続きもお任せください。',
  q3: '签证申请需要多长时间？',
  a3: '根据签证种类不同，工作签证约1-3个月，永住权申请约6-12个月。从文件准备到申请，用中文详细说明时间安排。',
  q4: '可以同时进行公司设立和经营管理签证吗？',
  a4: 'はい。公司设立手続きと经营管理签证申請を並行して行うことができます。事業計画書の作成から申請まで、用中文全面サポートします。',
  q5: '咨询费用是多少？',
  a5: '初次咨询免费。之后の手続きはサービス内容によって明確な料金が提示されます。も用中文詳細な料金を説明し、安心してお問い合わせください。',
  q6: '可以对应紧急手续吗？',
  a6: 'はい、も对应紧急案件。中文24時間以内に返信保証し、緊急案件も迅速に対応します。まず中文で電話してください。',
  q7: '可以用中文说明建设业许可的要求吗？',
  a7: 'もちろん、可能です。建設業許可の複雑な要件について、用中文詳細に説明します。経営責任者と専任技術者の要件、財産基礎等、全部用母語理解します。',
  q8: '归化申请的成功率是多少？',
  a8: '本事务所在中国客户的归化申請中で95%以上の成功率を有しています。中国籍制度を熟知した専門家、ファイルの準備から面接対策まで用中文全面サポートします。',
  ctaTitle: '其他问题请随时用中文咨询',
  ctaDesc: '除上述以外如有不明之处、用中文詳細に説明してください。どんな小さな問題でもお気軽にご相談ください。',
  ctaButton: '中文免费咨询',
};

export const footer = {
  tagline: '您值得信赖的法律合作伙伴',
  servicesTitle: '服务内容',
  service1: '签证・在留资格',
  service2: '公司设立',
  service3: '建设業许可',
  service4: '归化申请',
  officeInfoTitle: '事务所情報',
  pricing: '收费标准',
  testimonials: '客户评价',
  faq: '常见问题',
  contact: '联系我们',
  contactTitle: '联系方式',
  copyright: '© 2024 大家行政书士事务所. All rights reserved.',
  poweredBy: 'Powered by Readdy',
};

const zh = {
  ...navbar,
  ...hero,
  ...services,
  ...pricing,
  ...testimonials,
  ...contact,
  ...faq,
  ...footer,
};

export default zh;